// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__xyvVd","loader":"Loader_loader__yc1mt","spin":"Loader_spin__BsIxE"};